module.exports = __webpack_public_path__ + "d349c8a2444f06a7a54f16eec35398df.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/faction_campaign_3-660.webp
// module id = 305
// module chunks = 0